import { Entity } from './entity';

export class AppConfiguration extends Entity {
    
    public static readonly TABLENAME = 'app_configuration';

   public static readonly IS_VISIBLE = "is_visible";
    public static readonly VALUE_TYPE = "value_type";
    public static readonly DISPLAY_NAME = "display_name";
    public static readonly DISPLAY_NAME_ENG = "display_name_eng";
    
    id: number;
    name: string;
    value: string;
    companyId?: string | null;
    isVisible: boolean;
    valueType: string;
    displayName: string;
    displayNameEng: string;
    
}